import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import FiltroHistoricoEstornoItemPedidoInput from '@/core/apiclient/item-pedido/estorno/models/FiltroHistoricoEstornoItemPedidoInput'
// eslint-disable-next-line vue/max-len

export default {
	async [actionTypes.ITEM_PEDIDO.ESTORNO.DETALHES.BUSCAR](context, { idItemPedido }) {
		return await api.itemPedidoEstorno.buscarDetalhesEstornoItemPedido(
			new FiltroHistoricoEstornoItemPedidoInput(idItemPedido),
		)
	},
}
